import React, { useEffect, useState } from 'react';
import { SelectValue } from 'antd/lib/select';
import { DatePicker } from 'antd';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import moment, { Moment } from 'moment';
import DateRange from 'src/components/ProductDetails/types/DateRange';
import Select from 'src/components/common/Select';
import UserContex from 'src/services/UserContex';
import styles from './DateFilter.module.less';

type DateFilterProps = {
  onUpdate: (dateRange: DateRange | null) => void;
};

const { RangePicker } = DatePicker;
const { Option } = Select;

const dateOptions = [
  {
    name: 'This Month',
    id: '0',
  },
  {
    name: 'Last Month',
    id: '1',
  },
  {
    name: 'Last 3 Months',
    id: '3',
  },
  {
    name: 'Last 6 Months',
    id: '6',
  },
  {
    name: 'Year to date',
    id: '12',
  },
  {
    name: 'Custom Date Range',
    id: 'customDateRange',
  },
];

const getStartDate = (value: string): string => {
  const date = value === '0' ? moment() : moment().subtract(value, 'months');
  return date.startOf('month').format(UserContex.getDateFormat());
};

const getEndDate = (value: string): string => {
  const date = value === '0' || value === '12' ? moment() : moment().subtract('1', 'months').endOf('month');
  return date.format(UserContex.getDateFormat());
};

const disabledDate = (date: Moment | null): boolean => {
  return date ? date < moment().subtract(1, 'years').endOf('day') : false;
};

const DateFilter: React.FC<DateFilterProps> = ({ onUpdate }) => {
  const [dateId, setDateId] = useState<string | undefined>(undefined);
  const [dateRange, setDateRange] = useState<RangePickerValue>();
  const customDateRangeId = dateOptions[dateOptions.length - 1].id;

  const onDateChange = (value: SelectValue) => {
    const dateString = String(value || '');
    const dateRange: DateRange | null = dateString
      ? {
          startDate: getStartDate(dateString),
          endDate: getEndDate(dateString),
        }
      : null;

    onUpdate(dateRange);
    setDateId(dateString || undefined);
    setDateRange(undefined);
  };

  useEffect(() => {
    onDateChange('0');
  }, []);

  const onDateRangeChange = (value: RangePickerValue, range: [string, string]) => {
    const [startDate, endDate] = range;
    const dateRange: DateRange | null = startDate ? { startDate, endDate } : null;
    onUpdate(dateRange);
    if (value) {
      setDateRange(value);
    }
    setDateId(customDateRangeId);
  };

  return (
    <div className={styles.dateWrapper}>
      <div className={styles.datepicker}>
        <Select
          placeholder="Select Date Range"
          defaultValue={'This Month'}
          onChange={onDateChange}
          value={dateId}
          showArrow={true}
        >
          {dateOptions.map(({ id, name }, i) => {
            return (
              <Option value={id} key={`date-${name}-${i}`}>
                {name}
              </Option>
            );
          })}
        </Select>
        {dateId === customDateRangeId && (
          <RangePicker
            allowClear
            format={UserContex.getDateFormat()}
            onChange={onDateRangeChange}
            value={dateRange}
            disabledDate={disabledDate}
          />
        )}
      </div>
    </div>
  );
};

export default DateFilter;
